import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { compose, constants, links } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import HeaderCartButton from 'layouts/InsideLayout/Header/HeaderCartButton/HeaderCartButton'
import HeaderBanner from 'layouts/InsideLayout/Header/HeaderBanner/HeaderBanner'
import SearchInput from 'layouts/InsideLayout/Header/HeaderSearchInput/HeaderSearchInput'
import AlgoliaSearchInput from 'layouts/InsideLayout/Header/HeaderAlgoliaSearchInput/HeaderAlgoliaSearchInput'
import SubNav from 'layouts/InsideLayout/Header/HeaderSubNav/HeaderSubNav'
import Logo from 'components/ui/Logo/Logo'

import HamburgerButton from './HamburgerButton/HamburgerButton'
import LoginButton from './LoginButton/LoginButton'
import LandingSubNav from './LandingSubNav/LandingSubNav'
import InviteButton from './InviteButton/InviteButton'

import s from './Mobile.scss'


const HeaderMobile = (props) => {
  const {
    isLoggedIn, isNotEmptyPage, isCartNotEmpty, isAlgoliaSearchEnabled,
    withLandingSubNav, withSearchInput, withGiftSetsBanner, isSkincareIntroPage,
  } = props

  let searchInput = (() => {
    if (!withSearchInput || !isNotEmptyPage) {
      return null
    }

    if (isAlgoliaSearchEnabled) {
      return <AlgoliaSearchInput />
    }

    return <SearchInput isMobile />
  })()

  return (
    <Fragment>
      <header className={s.header}>
        <HamburgerButton className={s.menuButton} />
        {
          isLoggedIn && isNotEmptyPage && (
            <InviteButton className={s.inviteButton} />
          )
        }
        <Logo className={s.logo} dark redirect={!isSkincareIntroPage && links.home} />
        {
          isLoggedIn && (isNotEmptyPage || isCartNotEmpty) && (
            <div className={s.cartButton}>
              <HeaderCartButton />
            </div>
          )
        }
        {
          !isLoggedIn && (
            <LoginButton className={s.loginButton} />
          )
        }
      </header>
      {
        withLandingSubNav && (
          <LandingSubNav />
        )
      }
      {
        isLoggedIn && isNotEmptyPage && (
          <SubNav />
        )
      }
      {searchInput}
      {
        isLoggedIn && withGiftSetsBanner && (
          <HeaderBanner />
        )
      }
    </Fragment>
  )
}

HeaderMobile.propTypes = {
  withLandingSubNav: PropTypes.bool,
  withSearchInput: PropTypes.bool,
  withGiftSetsBanner: PropTypes.bool,

  // @injectGlobals
  isAlgoliaSearchEnabled: PropTypes.bool,

  // @connect
  isLoggedIn: PropTypes.bool,
  isCartNotEmpty: PropTypes.bool,
  isNotEmptyPage: PropTypes.bool,
}

HeaderMobile.defaultProps = {
  withLandingSubNav: false,
  withSearchInput: true,
  withGiftSetsBanner: true,
}


export default compose(
  injectGlobals(({ getAbValue, getFeatureToggle }) => ({
    isAlgoliaSearchEnabled:
      getFeatureToggle(constants.features.algoliaSearch)
      && getAbValue(constants.abTests.algoliaSearch) === 'b',
  })),
  connect({
    isLoggedIn: 'models.me.isLoggedIn',
    isCartNotEmpty: (state) => Boolean(state.models.cart.totalCount),
    isNotEmptyPage: (state) => {
      const { routing: { location: { pathname } } } = state

      return (
        pathname !== links.subscription.mainMenEmpty
        && pathname !== links.subscription.mainWomenEmpty
      )
    },
    isSkincareIntroPage: (state) => {
      const { routing: { location: { pathname } } } = state

      return pathname === links.skincareIntro
    },
  }),
)(HeaderMobile)
